import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import { ENABLE_MODAL_RETRIES } from '../../RequestManagerConstants';
      
class PurchaseButtonInfoV2Task extends AbstractRequestTask {
  constructor(params) {    
    super();    
    this.groupId = params.groupId;
    this.seasonId = params.seasonId;
    this.validateLogin = params.validateLogin || false;
    this.object_type = params.object_type
  }
  getHeaders() {
    const params = super.getParams();
    return {
        'Content-Type': 'application/json',
        'user-token': params.user_token
    };
  }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/payway/v2/purchasebuttoninfo`;
    }

    getParams() {
      const params = super.getParams();
      delete params.HKS;
      delete params.user_token;
      delete params.api_version;
      const dataParams = {
        group_id: this.groupId,
        season_id: this.seasonId,
        validatelogin: this.validateLogin,
        ...params,        
      };

      if(this.object_type)
        dataParams.object_type = this.object_type;

      return dataParams;
    }

    success(data, b) {
      this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
  }

export default PurchaseButtonInfoV2Task;
               



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PurchaseButtonInfoV2Task.js